const RevenueAgencyCrudModalLangKey = [
	'title_create',
	'title_edit',
	'title_remove_single',
	'title_notes_view',
	'title_notes_edit',
	'title_history_view',
	'field_name_label',
	'field_name_placeholder',
	'field_group_label',
	'field_group_placeholder',
	'field_fake_type_label',
	'field_fake_type_placeholder',
	'field_date_label',
	'field_date_placeholder',
	'field_percent_label',
	'field_percent_placeholder',
	'field_is_system_label',
	'field_is_active_label',
	'field_is_hold_label',
	'field_notes_label',
	'field_notes_placeholder',
	'msg_remove_confirm',
	'btn_add_record',
	'btn_create',
	'btn_update',
	'btn_remove',
	'btn_close'
] as const

type IRevenueAgencyCrudModalLangKey = typeof RevenueAgencyCrudModalLangKey[number]

export type IRevenueAgencyCrudModalLang = {
	revenue_agency_crud_modal: Record<IRevenueAgencyCrudModalLangKey, string>
}

const langEntries = RevenueAgencyCrudModalLangKey.map(
	(key: IRevenueAgencyCrudModalLangKey) => [key, `revenue_agency_crud_modal.${key}`]
)

const langObj: Record<IRevenueAgencyCrudModalLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_AGENCY_CRUD_MODAL_LANG_KEY: IRevenueAgencyCrudModalLang = {
	revenue_agency_crud_modal: langObj
}